export interface NormalizedError {
  code: string;
  message: string;
  details?: Record<string, string>;
  originalError?: unknown;
}

// Our internal error codes
export enum ErrorCode {
  // Generic errors (1xxxx)
  UNKNOWN = '10000',
  BAD_REQUEST = '10001',
  UNAUTHORIZED = '10002',
  FORBIDDEN = '10003',
  ROUTE_NOT_FOUND = '10004',
  VALIDATION = '10005',
  SERVER_ERROR = '10500',
  NETWORK_ERROR = '10006',
  
  // Content errors (2xxxx)
  RESOURCE_NOT_FOUND = '20001',
  CONTENT_INVALID = '20002',
  
  // Auth errors (3xxxx)
  AUTH_INVALID = '30001',
  AUTH_EXPIRED = '30002',
  
  // External service errors (4xxxx)
  EXTERNAL_SERVICE_ERROR = '40001',
  EXTERNAL_SERVICE_TIMEOUT = '40002',
} 